import React from "react"
import { compose, withProps } from "recompact"
import entityApi from "src/hocs/entity"
import eventTypeModel from "src/models/eventType"
import get from "lodash/get"

export default compose(
  withProps(props => ({ originalProps: { ...props } })),
  entityApi(({ originalProps }) => {
    const eventTypeId =
      get(originalProps, `eventTypeId.value`, undefined) ||
      originalProps.eventTypeId
    return {
      id: eventTypeId,
      to: `eventType`,
      model: eventTypeModel,
    }
  }),
  BaseComponent => ({ originalProps, eventType }) => (
    <BaseComponent {...originalProps} eventType={eventType} />
  ),
)
